import { Alert, Box } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import type { ComponentType } from 'react';
import { useSampleSet } from '../../../../../../contexts/SampleSetContext';
import {
  type AnalysisResultType,
  hasAnalysisViews,
} from '@/lib/jobs/analysisViews';
import HydraAnalytesTabRouter from '../../../../../../pages/experiments/resultsAnalysis/hydra/HydraAnalytesTabRouter';
import IdAnalytesTab from '../../../../../../pages/experiments/resultsAnalysis/id/IdAnalytesTab';
import MwmineFeaturesTab from '../../../../../../pages/experiments/resultsAnalysis/mwmineFeatures/MwmineFeaturesTab';
import PeptidesAnalytesTab from '../../../../../../pages/experiments/resultsAnalysis/peptides/PeptidesAnalytesTab';
import QuantAnalytesTab from '../../../../../../pages/experiments/resultsAnalysis/quant/QuantAnalytesTab';

const ANALYTES_TABS: Record<AnalysisResultType, ComponentType> = {
  QUANT: QuantAnalytesTab,
  ID: IdAnalytesTab,
  ID_PARQUET: HydraAnalytesTabRouter,
  HYDRA: HydraAnalytesTabRouter,
  PEPTIDES: PeptidesAnalytesTab,
  MWMINE_FEATURES: MwmineFeaturesTab,
};

export const Route = createFileRoute(
  '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/analytes'
)({
  staticData: { ddViewName: 'experiments-analytes-tab' },
  component: AnalytesRouteComponent,
});

function AnalytesRouteComponent() {
  const { selectedJob, selectedJobId } = useSampleSet();

  if (!selectedJobId) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          minHeight: '300px',
        }}
      >
        <Alert severity="info" sx={{ textAlign: 'center' }}>
          No inference runs available, upload samples and apply a program to
          analyze
        </Alert>
      </Box>
    );
  }

  // The layout sends the user to Samples when the run has no analysis views.
  const resultType = selectedJob?.result_type;
  if (!hasAnalysisViews(resultType)) {
    return null;
  }

  const AnalytesTab = ANALYTES_TABS[resultType];
  return <AnalytesTab />;
}
